import { baseApi } from "src/app/apis/baseApi"
import { toCamelCase } from "src/utils/data-transform"
import type { ProfileUser } from "./models/MeUser"

export const profileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfile: builder.query<{ data: ProfileUser }, void>({
      query: () => "/profile",
      transformResponse: (response) => toCamelCase(response),
    }),
  }),
  overrideExisting: false,
})

export const { useGetProfileQuery } = profileApi
